import { useHistory, useLocation } from "react-router-dom";
import Actions from "./components/Actions";
import {
  blockMember,
  complaintAboutMember,
  getMyMemberDetails,
  getProfileMember,
  leaveFootPrint,
} from "../../services/memberService";
import { useEffect, useState } from "react";
import { MemberProfile } from "../../typings/member";
import Button from "./components/Button";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import VerifiedProfile from "./components/VerifiedProfile";
import ProfileLoader from "./components/ProfileLoader";
import { HomeCarpetCategorySelectionType } from "../../typings/carpet";
import { TagProps } from "../../typings/tag";
import { GenderType, HomeCarpetFilterCategory } from "../../helpers/Enums";
import {
  setHomeCarpetFilterCategory,
  setNeedToRefresh,
} from "../../redux/carpet";
import NiceModal from "@ebay/nice-modal-react";
import { HOMEPAGE } from "../../navigation/Constants";
import { setProfileMemberData } from "../../redux/profileMember";
import GalleryLightBox from "../../components/GalleryLightBox";
import { getMemberMedia } from "../../services/mediaService";
import { borderRadius } from "@mui/system";
import { hideConversation } from "../../services/messageService";
import { setUserData } from "../../redux/member";

export interface ProfileViewProps {
  memberCode: number;
}

const ProfileView = ({ memberCode }: ProfileViewProps) => {
  const location = useLocation();
  const [member, setMember] = useState<MemberProfile>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { memberCode: myMemberCode } = useSelector(
    (state: RootState) => state.member
  );
  const { needToRefresh } = useSelector(
    (state: RootState) => state.profileMember
  );
  const [isShowGalary, setShowGalary] = useState<boolean>(false);
  const [media, setMedia] = useState<any>(null);
  let history = useHistory();
  const dispatch = useDispatch();

  const isMe = myMemberCode === memberCode;

  const memberState = useSelector((state: RootState) => state.member);

  useEffect(() => {
    fetchData();
  }, [memberCode]);

  useEffect(() => {
    if (needToRefresh) {
      fetchData();
      dispatch(setProfileMemberData({ needToRefresh: false }));
      window.scrollTo(0, 0);
    }
  }, [needToRefresh]);

  const fetchData = async () => {
    setIsLoading(true);
    const { data } = await getProfileMember(myMemberCode, memberCode);

    // const profileMedia = await getMemberMedia(memberCode);
    // console.log(profileMedia)

    setMedia(data.memberMedia.map((img) => img.mediaUrl));
    // setMedia(profileMedia.data.map(img => img.mediaUrl));
    setMember(data);
    setIsLoading(false);
    if (myMemberCode !== memberCode && !memberState.showMeAsOffline)
      await leaveFootPrint(myMemberCode, memberCode);
  };

  const navigateBack = () => {
    history.goBack();
    // NiceModal.hide("profile_modal");
  };

  const blockMemberRequest = async (confirmationTextStr: string) => {
    try {
      history.goBack();
      await blockMember(myMemberCode, memberCode);
      dispatch(setNeedToRefresh(true));

      //added the nice modal here for block
      NiceModal.show("action_modal", {
        onNext: () => {
          NiceModal.hide("action_modal");
        },
        headerTitle: confirmationTextStr,
        contentTitle:
          "מעכשיו, למי שחסמת לא תהיה אפשרות לצפות בפרופיל שלך או לשלוח לך הודעות",
        primaryButtonText: "בואו נמשיך",
        showCloseButton: true,
      });
    } catch (error: any) {
      NiceModal.hide("action_modal");
      //show something else;
    }
  };

  const hideChat = async () => {
    try {
      await hideConversation(myMemberCode, memberCode);
      const { data } = await getMyMemberDetails(memberState.memberCode);
      dispatch(setUserData(data));
      // dispatch(setNeedToRefresh(true));
      document.dispatchEvent(new CustomEvent("refresh-conversation-list"));
      // history.push(CONVERSTAION);
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleComplaintAboutMember = async (
    complaintId: number,
    complaintText: string
  ) => {
    try {
      const request = {
        memberCode: myMemberCode,
        complaintMemberCode: memberCode,
        complaintId,
        complaintText,
      };
      await complaintAboutMember(request);
      NiceModal.hide("reportMember_modal");
      NiceModal.show("action_modal", {
        onNext: () => {
          NiceModal.hide("action_modal");
          history.goBack();
        },
        headerTitle: "תודה!",
        contentTitle: "קיבלנו  את הדיווח שלך והעברנו אותו לבדיקה",
        primaryButtonText: "בואו נמשיך",
        showCloseButton: true,
      });
    } catch (error) {
      NiceModal.hide("reportMember_modal");
    }
  };

  const doubleMatchIcon = () => {
    switch (member?.doubleMatch.doubleMatchType) {
      case 2:
        return (
          <img src="/assets/images/ic_bou_bordo.svg" loading="lazy" alt="" />
        );
      case 3:
        return (
          <img src="/assets/images/ic_shosh_red.svg" loading="lazy" alt="" />
        );
      case 4:
        return (
          <img src="/assets/images/ic_bou_violet.svg" loading="lazy" alt="" />
        );
    }
  };

  const stickerIcon = () => {
    if (member?.doubleMatch.isSentMeSticker)
      return <img src="/assets/images/ic_gift_sm.svg" loading="lazy" alt="" />;
  };

  // const onTagSelect = (tag: TagProps) => {
  //    const tagFilter: HomeCarpetCategorySelectionType = {
  //       value: HomeCarpetFilterCategory.TAG,
  //       text: tag.text,
  //       tagValue: tag.value
  //    };
  //    dispatch(setHomeCarpetFilterCategory(tagFilter));
  //    NiceModal.hide("profile_modal");
  // };

  const matchedTagStyle = {
    backgroundColor: "#ee4234",
    color: "white",
  };

  const onlineStatus = {
    marginLeft: "5px",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    border: "1px solid gray",
    backgroundColor: "green",
  };

  const offlineStatus = {
    marginLeft: "5px",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    border: "1px solid gray",
    backgroundColor: "red",
  };

  return (
    <>
      {isLoading ? (
        <ProfileLoader />
      ) : (
        <>
          <div
            className="top_sec full wf-section"
            style={{ minHeight: "100px" }}
          >
            <div className="top_content profile">
              <a
                href="#"
                className="top_back w-inline-block"
                onClick={navigateBack}
              >
                <img
                  src="/assets/images/ic_back_white.svg"
                  loading="lazy"
                  alt=""
                />
              </a>
              <div className="full_prof_info">
                <div className="user_basic_info">
                  <h2 className="user_name" dir="rtl">
                    {member?.userName}
                  </h2>
                  <div className="age_txt">, {member?.age}</div>
                  {member?.profileIsVerified &&
                  member?.hasBeenAuthenticatedByPhone ? (
                    <div className="ic_vi" />
                  ) : null}
                </div>
                <div
                  className="user_add_info"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {/* <div style={{ marginLeft: '5px' }}>{member?.personalStatus},</div>
                              <div className="user_place_txt">{member?.residentCityName}</div>
                              <div style={member?.isOnline ? onlineStatus : offlineStatus}></div>
                              {member?.isOnline && <div style={{ marginLeft: '3px' }}>אונליין עכשיו</div>} */}
                  <div>
                    {" "}
                    {member?.personalStatus
                      ? `${member.personalStatus}`
                      : ""}{" "}
                  </div>
                  <div>
                    {" "}
                    {member?.residentCityName
                      ? `, ${member.residentCityName}`
                      : ""}
                  </div>
                  <div>
                    {" "}
                    {member?.isOnline
                      ? member.genderId === GenderType.MALE
                        ? ", מחובר"
                        : ", מחוברת"
                      : ""}{" "}
                  </div>
                </div>
              </div>
              {isMe ? null : (
                <Actions
                  handleBlockMember={blockMemberRequest}
                  complaintAboutMember={handleComplaintAboutMember}
                  matchType={member?.doubleMatch.doubleMatchType}
                  isChatScreen={false}
                  hideChat={hideChat}
                />
              )}
            </div>
          </div>
          <div className="content_sec full wf-section">
            <div className="content_block">
              <div
                className="profile_pict_group"
                onClick={() => setShowGalary(true)}
              >
                <div className="item_pict_block">
                  {media?.length > 1 && (
                    <div
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        color: "white",
                        backgroundColor: "rgba(0,0,0,0.3)",
                        padding: "0 5px",
                        borderRadius: "15px",
                        fontSize: "0.9rem",
                        fontWeight: "normal",
                      }}
                    >
                      {media?.length} \ 1
                    </div>
                  )}
                  {member?.profileImageUrl && (
                    <img
                      src={member?.profileImageUrl}
                      loading="lazy"
                      alt=""
                      className="item_pict"
                    />
                  )}
                </div>
                <div className="gallery_prof_info full">
                  {(member?.isFreezedAccount ||
                    member?.mediaRequierdVerification) && (
                    <div
                      className="flah full"
                      style={{ backgroundColor: "gray" }}
                    >
                      פרופיל בהקפאה
                    </div>
                  )}
                  {member?.moodName && (
                    <div className="flah full">אשמח ל{member?.moodName}</div>
                  )}
                  <h2 className="user_name full">{member?.profileSentence}</h2>
                  {/* {
                                 member?.profileStatementUpdate === "never"
                                    ? null
                                    : <div>עודכן {member?.profileStatementUpdate}</div>
                              } */}
                  {/*```````````````````````````````````````````````````````*/}

                  <div className="item_status_group">
                    <div className="status_icon">{doubleMatchIcon()}</div>
                    <div className="status_icon gift">{stickerIcon()}</div>
                  </div>
                  {/*```````````````````````````````````````````````````````*/}
                </div>
                {media?.length > 1 && (
                  <>
                    <a href="#" className="prof_pict_arrow left w-inline-block">
                      <div className="w-icon-slider-left" />
                    </a>
                    <a href="#" className="prof_pict_arrow w-inline-block">
                      <div className="w-icon-slider-right" />
                    </a>
                  </>
                )}
              </div>
              <div className="profile_info_group">
                <ul className="info_group_list w-list-unstyled">
                  <li className="info_group_item">
                    <div className="property_txt title">רוצה להכיר:</div>
                    <div className="property_txt">
                      {member?.lookingFor.join(" / ")}
                    </div>
                  </li>

                  {member?.profileQuestions.map((question, index) => {
                    if (question.tags[0].text !== "לא רלוונטי")
                      return (
                        <li key={index} className="info_group_item">
                          <div className="property_txt title">
                            {question.questionName}:
                          </div>
                          {question.tags.length > 1 ? (
                            <div className="property_txt">
                              {question.tags.map((x) => x.text).join(" / ")}
                            </div>
                          ) : (
                            <div className="property_txt">
                              {question.tags[0].text}
                            </div>
                          )}
                        </li>
                      );
                  })}
                  {member?.height !== 0 && member?.height !== null && (
                    <li className="info_group_item">
                      <div className="property_txt title">גובה:</div>
                      <div className="property_txt">{member?.height} ס"מ</div>
                    </li>
                  )}
                </ul>
                {member?.aboutMeDescription && (
                  <p style={{ whiteSpace: "pre-line" }}>
                    <b>קצת עלי</b>
                    <br />
                    {member?.aboutMeDescription}
                  </p>
                )}
                <ul className="cat_tag_list w-list-unstyled">
                  {member?.tagsQuestions.filter(
                    (tag) => tag.text !== "לא רלוונטי"
                  ).length !== 0 && (
                    <li className="cat_tag_item">
                      <ul className="tag_list w-list-unstyled">
                        {member?.tagsQuestions
                          ?.filter((tag) => tag.text !== "לא רלוונטי")
                          .map((tag, index) => {
                            return (
                              <li key={index} className="tag_item">
                                <div
                                  className="tag_link"
                                  style={
                                    member?.matchTags?.includes(tag.value)
                                      ? matchedTagStyle
                                      : {}
                                  }
                                >
                                  {tag.text}
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                    </li>
                  )}
                  {member &&
                    member.tagsHeadersQuestions.length !== 0 &&
                    member.tagsHeadersQuestions.map((question, index) => {
                      //const isSelected = member.matchTags.includes(tag.value);
                      return question.tags.length === 1 &&
                        question.tags[0].text === "לא רלוונטי" ? null : (
                        <li className="cat_tag_item" key={index}>
                          <h3 className="cat_tag_title">
                            {question.questionName}
                          </h3>
                          <ul className="tag_list w-list-unstyled">
                            {question.tags
                              .filter((tag) => tag.text !== "לא רלוונטי")
                              .map((tag, value) => {
                                return (
                                  <li className="tag_item" key={value}>
                                    <div
                                      className="tag_link"
                                      style={
                                        member?.matchTags?.includes(tag.value)
                                          ? matchedTagStyle
                                          : {}
                                      }
                                    >
                                      {tag.text}
                                    </div>
                                  </li>
                                );
                              })}
                          </ul>
                        </li>
                      );
                    })}
                </ul>
                <VerifiedProfile
                  lastSeenOnline={member?.lastSeenOnline}
                  memeberImage={member?.profileImageUrl}
                  isVerified={
                    member?.profileIsVerified &&
                    member?.hasBeenAuthenticatedByPhone
                  }
                />
              </div>
            </div>
          </div>
          {isMe ? null : (
            <Button
              memberCode={memberCode}
              memberName={member?.memberName}
              userName={member?.userName}
              memberImage={member?.profileImageUrl}
              bounakirMessage={member?.doubleMatch.bounakirMessage}
              doubleMatchType={member?.doubleMatch.doubleMatchType}
            />
          )}
        </>
      )}

      {isShowGalary && media?.length > 1 && (
        <GalleryLightBox
          isOpen={isShowGalary}
          images={media}
          onClose={() => setShowGalary(false)}
          imagePage={0}
          mediaLength={media?.length}
        />
      )}
    </>
  );
};

export default ProfileView;
